import Vue from 'vue'
import App from './App.vue'
import Router from 'vue-router';
import VueAnalytics from 'vue-analytics'
import VueGtag from "vue-gtag";

// eslint-disable-next-line
const Page = r => require(['@/components/Page.vue'], r);

import FormRegister from './components/FormRegister.vue';
import PageResult from './components/PageResult.vue';
Vue.config.productionTip = false

import store from './store';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  linkActiveClass: 'active',
  linkExactActiveClass: 'exact-active',
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: '/:language',
      redirect: 'form',
      component: Page,
      children: [
        {
          path: 'onde-encontrar',
          name: 'form',
          component: FormRegister,
        },
        {
          path: 'onde-encontrar/resultado',
          name: 'result',
          component: PageResult,
        },
      ]
    },
    {
      path: '*',
      redirect: '/pt/onde-encontrar',
    },
  ],
});

Vue.use(VueAnalytics, {
  id: '',
  router
})

Vue.use(VueGtag, {
  config: { id: 'GTM-PQFLQGW3' },
})

new Vue({
  store,
  router,
  render: h => h(App),
}).$mount('#app')
